import { CSSObject, Flex, FlexProps } from '@chakra-ui/react'
import React, { useMemo } from 'react'

export const LayoutPadding: React.FC<FlexProps> = props => (
  <Flex
    bg="neutral.10"
    direction="column"
    flex="1 1 auto"
    height="100%"
    position="relative"
    pt={[5, 10]}
    px={[5, 20]}
    {...props}
  />
)

interface PageContainerProps extends FlexProps {
  printStyle?: Record<string, string | number | object>
}

export const PageContainer: React.FC<PageContainerProps> = ({
  printStyle,
  ...props
}) => {
  const printProps: CSSObject | undefined = useMemo(
    () =>
      printStyle &&
      ({
        '@media print': printStyle,
      } as CSSObject),
    [printStyle],
  )
  return (
    <Flex
      flex="1 1"
      flexDirection="column"
      height="100%"
      position="relative"
      py={{ base: '5px', sm: 'unset' }}
      sx={printProps}
      {...props}
    />
  )
}
